import { useId } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { formatBookingPrice } from "../../utils/bookingPrice";

export const bookingDemoServices = [
  { id: "podcast", name: "Your podcast", priceCents: 1000 },
  { id: "show", name: "John Doe's show", priceCents: 30000 },
  { id: "ai", name: "AI implementation", priceCents: 300000 },
];

export default function BookMePreview({ onSelect }) {
  const groupName = useId();
  return <div className="bookingOverview__previewModal" aria-label="Book Me service preview">
    <div className="bookingOverview__previewHeader"><strong>Book Me</strong><CloseOutlined aria-hidden="true" /></div>
    <div className="bookingOverview__previewServices" role="radiogroup" aria-label="Preview services">
      {bookingDemoServices.map((service, index) => <label className="bookingOverview__previewService" key={service.id}>
        <input className="bookingOverview__previewRadio" type="radio" name={groupName}
          value={service.id} defaultChecked={index === 0} onChange={() => onSelect?.(index)} />
        <span className="bookingOverview__previewName">{service.name}</span><strong>{formatBookingPrice(service.priceCents)}</strong>
      </label>)}
    </div>
    <div className="bookingOverview__previewPayment" aria-hidden="true">Continue to payment</div>
  </div>;
}
